import {ColumnsType} from 'antd/es/table';

import {EMonitoringStatusCode} from 'store/slices/documents-uploading-slice';

export const UPLOAD_DOCUMENT_URL = 'monitor/download-attach-and-mark';
export const UPLOAD_LOG_URL = 'administration.monitor.programs/download/';
export const MODAL_UPDATE_DELAY = 20000;

export enum EDownloadReportDocumentsFields {
    ProgramName = 'programName',
    UploadedFilename = 'uploadedFilename',
    UploadedDocTypeName = 'uploadedDocTypeName',
    InnerRequests = 'innerRequests',
    DownloadFiles = 'downloadFiles',
    Id = 'id',
    AttachId = 'attachId'
}

export const DownloadReportDocumentsFieldsWidth: Record<string, number> = {
    [EDownloadReportDocumentsFields.ProgramName]: 384,
    [EDownloadReportDocumentsFields.UploadedFilename]: 392,
    [EDownloadReportDocumentsFields.UploadedDocTypeName]: 351,
    [EDownloadReportDocumentsFields.InnerRequests]: 172,
    [EDownloadReportDocumentsFields.DownloadFiles]: 256,
};

export const DownloadReportStatuses: Record<string, string> = {
    [EMonitoringStatusCode.normal]: 'success',
    [EMonitoringStatusCode.onHold]: 'onHold',
    [EMonitoringStatusCode.running]: 'running',
    [EMonitoringStatusCode.warning]: 'warning',
    [EMonitoringStatusCode.error]: 'error',
};

export const DownloadDocumentsColumns: ColumnsType<Record<string, EDownloadReportDocumentsFields>> = [
    {
        title: 'Имя программы',
        dataIndex: EDownloadReportDocumentsFields.ProgramName,
        key: EDownloadReportDocumentsFields.ProgramName,
    },
    {
        title: 'Загружаемый файл',
        dataIndex: EDownloadReportDocumentsFields.UploadedFilename,
        key: EDownloadReportDocumentsFields.UploadedFilename,
    },
    {
        title: 'Тип документа',
        dataIndex: EDownloadReportDocumentsFields.UploadedDocTypeName,
        key: EDownloadReportDocumentsFields.UploadedDocTypeName,
    },
    {
        title: 'Статус',
        dataIndex: EDownloadReportDocumentsFields.InnerRequests,
        key: EDownloadReportDocumentsFields.InnerRequests,
    },
    {
        title: 'Сформированный файл',
        dataIndex: EDownloadReportDocumentsFields.DownloadFiles,
        key: EDownloadReportDocumentsFields.DownloadFiles,
    },
];
